<template>
    <b-btn variant="success" to="create" :append="true">
        <span v-if="$screen.md && $screen.lg">Create</span>
        <span v-else>+</span>
    </b-btn>
</template>
<script>
export default {
    name: 'CreateButton',
    mounted() {}
}
</script>